import type { Project } from "@storytell/types";

/**
 * Orders matches most-recently-visited first, everything else newest-first. An empty query matches
 * everything, which is what makes recents the switcher's resting state.
 *
 * Sorts a copy; the input array is left alone.
 */
export const rankProjects = (projects: Project[], query: string, recentProjectIds: string[]): Project[] => {
  const needle = query.trim().toLowerCase();
  const matched = needle
    ? projects.filter(
        (project) => project.name.toLowerCase().includes(needle) || project.description.toLowerCase().includes(needle)
      )
    : projects;

  const recency = new Map(recentProjectIds.map((id, index) => [id, index]));
  const rank = (project: Project) => recency.get(project.id) ?? recentProjectIds.length;
  // Parsed up front rather than in the comparator, which would re-parse both
  // sides of every comparison.
  const touched = new Map(matched.map((p) => [p.id, Date.parse(p.modifiedAt || p.createdAt)]));
  const touchedAt = (project: Project) => touched.get(project.id) ?? 0;

  return matched.toSorted((a, b) => rank(a) - rank(b) || touchedAt(b) - touchedAt(a));
};
